










import { Component, Prop, Vue } from 'vue-property-decorator'
import { PropType } from 'vue'
import { TrelloCard } from '@/TrelloClient'
import { uiConfig } from '../../config'

@Component({
    props: {
        card: Object as PropType<TrelloCard>,
    },
})
export default class extends Vue {
}
